<!--农村公路大数据云平台-->
<template>
    <div class="system-container">
        <div class="section">
            <div class="section-content">
                <div class="title">平台概述</div>
                <div class="panel-text">
                    <img class="img" src="@/assets/image/prescription/sys_5.png" alt="">
                    <p class="about">
                        农村公路已基本形成遍布农村、连接城乡的农村公路网络，在给我们带来便捷的同时也对管养工作带来了严峻挑战，
                        如何延长农村公路使用寿命，提升养护管理水平，促进可持续健康发展，已成为各管养单位亟待解决的问题，必须借
                        助信息化技术的发展，应用物联网、全息感知、云计算、大数据等先进技术，将公路“建、养、管、运”纳入统一平台
                        进行管理，以数据资源赋能交通发展为切入点，按照统筹协调、应用驱动、安全可控、多方参与的原则，聚焦基础支
                        撑、共享开放、创新应用、安全保障、管理改革等重点环节，实施综合交通运输大数据深度融合，有效构建综合交通
                        大数据中心体系，为加快建设交通强县提供有力支持，最终实现信息化管理，服务于民。
                    </p>
                </div>
            </div>
        </div>
        <div class="section" style="background-color: #EAF3FF">
            <div class="section-content">
                <div class="title">平台架构</div>
                <Carousel class="carousel" :images="imageList" height="800px"/>
                <el-carousel class="mobile-carousel" height="200px" trigger="click">
                    <el-carousel-item v-for="(item,index) in imageList" :key="index">
                        <el-image
                            :src="item"
                            style="width: 100%;height: 100%;object-fit: scale-down"
                        >
                        </el-image>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <div class="section">
            <div class="section-content">
                <div class="title">核心功能</div>
                <div class="core-panel">
                    <div class="panel" v-for="(item,index) in coreFuncList" :key="index">
                        <div class="header" :style="{backgroundImage:`url(${item.bg})`}">
                            <img class="img" :src="item.icon" alt="">
                        </div>
                        <div class="mobile-header" :style="{backgroundImage:`url(${item.bg})`}">
                            <img class="img" :src="item.icon" alt="">
                        </div>
                        <div class="content">
                            <div class="label">{{ item.label }}</div>
                            <ul class="list">
                                <li class="list-item" v-for="(_item,_index) in item.funcList" :key="_index">
                                    {{ _item }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section" style="background-color: #EAF3FF">
            <div class="section-content">
                <div class="title">应用价值</div>
                <div class="panel-content">
                    <div class="panel" v-for="(item,index) in panelList" :key="index">
                        <img :src="item.icon" alt="" style="width: 100px;height: 100px;"/>
                        <div class="content">
                            <div class="label">{{ item.label }}</div>
                            <p class="article">
                                {{ item.text }}
                            </p>
                        </div>
                    </div>
                    <!--移动端适配-->
                    <div class="mobile-panel" v-for="(item,index) in panelList" :key="index">
                        <div class="head">
                            <img class="img" :src="item.icon" alt=""/>
                            <div class="label">{{ item.label }}</div>
                        </div>
                        <p class="article">
                            {{ item.text }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//components
import Carousel from '@/components/Carousel'

export default {
    components: {
        Carousel
    },
    name: 'ruralRoadBigData',
    data() {
        return {
            imageList: [
                require('@/assets/image/prescription/system_structure.png'),
                require('@/assets/image/prescription/system_structure.png'),
                require('@/assets/image/prescription/system_structure.png')
            ],
            coreFuncList: [
                {
                    bg: require('@/assets/image/prescription/func_bg1.jpg'),
                    icon: require('@/assets/image/prescription/icon_27.png'),
                    label: '公路建设',
                    funcList: ['计划管理', '进度管理', '质量管理', '安全管理']
                },
                {
                    bg: require('@/assets/image/prescription/func_bg2.png'),
                    icon: require('@/assets/image/prescription/icon_28.png'),
                    label: '监督管理',
                    funcList: ['科技治超', '视频监控', '安防监测', '督察考核']
                },
                {
                    bg: require('@/assets/image/prescription/func_bg3.jpg'),
                    icon: require('@/assets/image/prescription/icon_29.png'),
                    label: '养护巡查',
                    funcList: ['路长制', '智慧路产', '技术状况评定', '巡查养护']
                },
                {
                    bg: require('@/assets/image/prescription/func_bg4.jpg'),
                    icon: require('@/assets/image/prescription/icon_30.png'),
                    label: '运营服务',
                    funcList: ['车辆监管', '路衍经济', '农产品电商', '农客预约']
                }
            ],
            panelList: [
                {
                    icon: require('@/assets/image/prescription/icon_31.png'),
                    label: '有助于成功创建全省、全国农村公路示范县',
                    text: '建设农村公路大数据云平台为创建“四好农村路”省级、国家级示范县评分细则中明确要求，聚焦农村公路建设、管理、养护、运营各方面信息化建设及应用，不仅可以推动“四好农村路”高质量发展，也有助于成功创建全省、全国农村公路示范县，服务支撑乡村振兴和农业农村现代化发展。'
                },
                {
                    icon: require('@/assets/image/prescription/icon_32.png'),
                    label: '有助于提高交通管理和社会服务水平',
                    text: `本项目的实施，能够为县区交通局主管部门提供信息化、网络化、智能化的管理手段，建立了集感知、预警、分析、决策、应用“五位一体”的农村公路大数据云平台，对人、车、物、事整合管控，
                    推动农村公路资产管理数字化、养护巡查可视化、养护决策科学化，实现农村公路工作调度一体化、数据应用一个库、过程监管一条线、 建管养运一盘棋的新时代数字化管理体系，使区域内所有农村公路
                    建管养运得到有效监管，全面提高农村公路管理养护效率，营造良好的农村公路出行环境，赋能乡村振兴全面发展。公众提供实时方便的交通诱导信息服务，能够进一步提高管理部门的决策水平，提升交通
                    管控能力和社会服务水平，促进智能交通的发展。全面提升洋县智能交通管理水平。`
                },
                {
                    icon: require('@/assets/image/prescription/icon_33.png'),
                    label: '有助于促进经济社会可持续发展',
                    text: '对推进县区交通现代化，夯实经济发展基础具有重大意义。项目建设一方面有利于激发民众潜在出行需求，拉动内需，另一方面将推进产业集聚，改善洋县投资环境，吸引更多的投资者和专业人才，从而推进洋县经济快速发展。'
                },
            ]
        }
    },
    mounted() {
    },
    methods: {
        //切换图片
        toggleImage(type) {
            this.$refs.carousel[type]()
        }
    }
}
</script>


<style scoped lang="scss">
.system-container {
    height: 100%;
    width: 100%;

    .section {
        height: 100%;
        width: 100%;

        .section-content {
            margin: 0 auto;
            width: 1200px;
            padding: 50px 0;

            .title {
                text-align: center;
                font-size: 32px;
            }

            .text {
                margin-top: 40px;
                text-indent: 2em;
                line-height: 32px;
            }

            .image {
                margin-top: 60px;
                width: 100%;
            }
        }
    }

    .mobile-carousel {
        display: none;
    }

    .panel-text {
        margin-top: 80px;
        padding: 50px 80px 50px 0;
        background-image: url("~@/assets/image/prescription/blue_bg.png");
        background-repeat: no-repeat;
        background-size: 60% 100%;
        background-position: right;
        display: flex;

        .img {
            width: 580px;
            height: 327px
        }

        .about {
            box-sizing: border-box;
            padding-left: 50px;
            text-align: justify;
            text-indent: 2em;
            line-height: 32px;
            color: #ffffff;
        }
    }

    .core-panel {
        margin-top: 80px;
        display: flex;
        justify-content: space-between;

        .panel {
            width: calc(25% - 32px);

            .mobile-header {
                display: none;
            }

            .header {
                background-size: 100% 100%;
                height: 200px;
                display: flex;
                align-items: center;
                flex-direction: column;


                .img {
                    height: 72px;
                    width: 72px;
                    margin-top: auto;
                    transform: translateY(50%);
                }
            }

            .content {
                border: 1px solid #DCDCDC;
                border-top: none;
                padding: 60px 0 30px 0;

                .label {
                    text-align: center;
                    font-size: 24px;
                }

                .list {
                    margin-top: 8px;

                    .list-item {
                        padding: 8px 0;
                        text-align: center;
                        font-size: 18px;
                    }
                }
            }


        }
    }

    .panel-content {
        margin-top: 80px;

        .mobile-panel {
            display: none;
        }

        .panel {
            padding: 30px;
            border-radius: 4px;
            box-shadow: 0 3px 18px 1px rgba(26, 102, 187, 0.14);
            margin-bottom: 30px;
            display: flex;

            .content {
                padding-left: 30px;

                .label {
                    font-size: 24px;
                    font-weight: bold;
                    color: #333333;
                    padding: 8px 0;
                }

                .article {
                    margin-top: 16px;
                    text-align: justify;
                    line-height: 30px;
                    font-size: 20px;
                }
            }
        }
    }
}

@import "./style.scss";
</style>
